/** Keep contextual controls above the bottom dock and the compact navigation row. */
export const workspaceBottomInset = (width: number) =>
  width <= 1400 ? 144 : 88;
